import { User } from 'lucide-react';
import { Link } from 'react-router-dom';
import Card from '@/components/ui/Card';
import { formatCurrency, formatDate } from '@/lib/utils';
import type { Order } from './types';

interface CustomerCardProps {
  customer: Order['customer'];
  email: string;
}

export default function CustomerCard({ customer, email }: CustomerCardProps) {
  return (
    <Card title="Customer" padding="md">
      <div className="space-y-3">
        {customer ? (
          <>
            <div className="flex items-center gap-2">
              <User className="h-4 w-4 text-stone-400" />
              <span className="text-sm font-medium text-stone-900">
                {customer.first_name} {customer.last_name}
              </span>
            </div>

            <div className="text-sm">
              <a href={`mailto:${customer.email}`} className="text-blue-600 hover:underline">
                {customer.email}
              </a>
            </div>

            {customer.phone && (
              <div className="text-sm text-stone-700">{customer.phone}</div>
            )}

            {(customer.member_since || customer.total_orders !== undefined || customer.total_spent !== undefined) && (
              <div className="text-xs text-stone-500">
                {customer.member_since && `Member since ${formatDate(customer.member_since)}`}
                {customer.total_orders !== undefined && (
                  <>{customer.member_since ? ' · ' : ''}{customer.total_orders} orders</>
                )}
                {customer.total_spent !== undefined && (
                  <> · {formatCurrency(Number(customer.total_spent))} spent</>
                )}
              </div>
            )}

            <Link
              to={`/admin/customers/${customer.id}`}
              className="inline-block text-sm text-blue-600 hover:underline mt-1"
            >
              View Customer
            </Link>
          </>
        ) : (
          <>
            <div className="flex items-center gap-2">
              <User className="h-4 w-4 text-stone-400" />
              <span className="text-sm font-medium text-stone-500">Guest</span>
            </div>
            <div className="text-sm">
              <a href={`mailto:${email}`} className="text-blue-600 hover:underline">
                {email}
              </a>
            </div>
          </>
        )}
      </div>
    </Card>
  );
}
